const SESSION_KEEP_ALIVE_PRIORITY_EVENT = 'milca:session-keep-alive-priority';

let priorityActive = false;

export const setSessionKeepAlivePriorityActive = (active: boolean) => {
  priorityActive = active;
  window.dispatchEvent(
    new CustomEvent<boolean>(SESSION_KEEP_ALIVE_PRIORITY_EVENT, { detail: active })
  );
};

export const getSessionKeepAlivePriorityActive = () => priorityActive;

export const subscribeSessionKeepAlivePriority = (listener: (active: boolean) => void) => {
  const handler = (event: Event) => {
    listener((event as CustomEvent<boolean>).detail);
  };

  window.addEventListener(SESSION_KEEP_ALIVE_PRIORITY_EVENT, handler);

  return () => {
    window.removeEventListener(SESSION_KEEP_ALIVE_PRIORITY_EVENT, handler);
  };
};
